import React, { useState } from 'react';
import {
  FiChevronRight,
  FiDownload,
} from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';

import { TopBar } from '@/design-system/components/organisms/TopBar';
import { DocumentModal } from '@/features/onboarding/components/DocumentModal';
import { NewApontamentoModal } from '@/features/onboarding/components/NewApontamentoModal';
import { Sidebar } from '@/features/onboarding/components/Sidebar';
import { ONBOARDING_SIDEBAR_ITEMS } from '@/shared/constants/sidebar.constants';

export const RejectedClientApontamentosPage: React.FC = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [isApontamentoModalOpen, setIsApontamentoModalOpen] = useState(false);
  const [currentDocument, setCurrentDocument] = useState({ title: '', url: '' });

  const handleOpenDocument = (title: string, url?: string) => {
    setCurrentDocument({ title, url: url || '' });
    setIsDocumentModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <TopBar />

      <div className="flex">
        {/* Sidebar */}
        <Sidebar items={ONBOARDING_SIDEBAR_ITEMS} className="w-64 min-h-[calc(100vh-140px)]" />

        {/* Main Content */}
        <main className="flex-1 p-8">
          <div className="max-w-7xl mx-auto">
            {/* Breadcrumbs */}
            <div className="flex items-center gap-2 text-sm text-neutral-600 mb-6">
              <button
                type="button"
                onClick={() => navigate('/onboarding/rejected')}
                className="hover:text-purple-600 transition-colors"
              >
                Reprovados
              </button>
              <FiChevronRight className="w-4 h-4" />
              <button
                type="button"
                onClick={() => navigate(`/onboarding/rejected/client/${clientId ?? ''}`)}
                className="hover:text-purple-600 transition-colors"
              >
                Cliente
              </button>
              <FiChevronRight className="w-4 h-4" />
              <span className="text-neutral-800 font-medium">Apontamentos</span>
            </div>

            {/* Header */}
            <div className="flex items-center gap-4 mb-6">
              <h1 className="text-3xl font-bold text-neutral-800">FIDUCIA SCM</h1>
              <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm font-medium">
                Formal
              </span>
              <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm font-medium">
                Blocklist
              </span>
            </div>

            {/* Histórico de apontamentos */}
            <div className="bg-white rounded-lg border border-neutral-200 p-6 mb-6">
              <h2 className="text-lg font-semibold text-neutral-800 mb-4">
                Histórico de apontamentos
              </h2>

              <div className="space-y-4">
                {/* Apontamento 1 */}
                <div className="border border-neutral-200 rounded-lg p-4">
                  <div className="flex items-start justify-between mb-3">
                    <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">
                      Tipo de apontamento
                    </span>
                  </div>
                  <p className="text-sm text-neutral-600 mb-2">
                    26/10/2025 às 10h30 - Camila Oliveira
                  </p>
                  <p className="text-sm text-neutral-800 mb-4">
                    Encontrado informações divergentes, será necessário uma análise mais profunda.
                  </p>
                  <button
                    type="button"
                    onClick={() => { handleOpenDocument('Documento complementar'); }}
                    className="flex items-center gap-2 px-4 py-2 bg-white border-2 border-purple-600 rounded-lg text-sm font-medium text-neutral-700 hover:bg-purple-50 transition-colors"
                  >
                    <FiDownload className="w-4 h-4" />
                    Documento complementar
                  </button>
                </div>

                {/* Apontamento 2 */}
                <div className="border border-neutral-200 rounded-lg p-4">
                  <div className="flex items-start justify-between mb-3">
                    <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium">
                      Onboarding reprovado
                    </span>
                  </div>
                  <p className="text-sm text-neutral-600 mb-2">
                    26/10/2025 às 10h30 - Camila Oliveira
                  </p>
                  <p className="text-sm text-neutral-800">
                    Análise concluída e aprovada.
                  </p>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={() => navigate(`/onboarding/rejected/client/${clientId ?? ''}`)}
                className="px-6 py-3 bg-white border-2 border-purple-600 text-neutral-700 rounded-lg font-medium hover:bg-purple-50 transition-colors"
              >
                Voltar
              </button>
              <button
                type="button"
                onClick={() => { setIsApontamentoModalOpen(true); }}
                className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors"
              >
                Novo apontamento
              </button>
            </div>
          </div>
        </main>
      </div>

      {/* Document Modal */}
      <DocumentModal
        isOpen={isDocumentModalOpen}
        onClose={() => { setIsDocumentModalOpen(false); }}
        documentTitle={currentDocument.title}
        documentUrl={currentDocument.url}
      />

      {/* Apontamento Modal */}
      <NewApontamentoModal
        isOpen={isApontamentoModalOpen}
        onClose={() => { setIsApontamentoModalOpen(false); }}
        onSubmit={() => {
          setIsApontamentoModalOpen(false);
          // Handle submit logic here
        }}
      />
    </div>
  );
};
